export default function Filter() {
  let selectedEstadoIds = [];

  function selectCheckedLoad(param) {
    let url = new URL(window.location.href);

    let params = new URLSearchParams(url.search);

    let categoriaValue = params.getAll(param);

    return categoriaValue;
  }

  function renderizarCategoria(categorias, subcategorias) {
    
  
    const wrapperContainer = document.querySelector(
      ".custom-dropdown-content .cols"
    );
    const categoriasAgrupadas = {};
    // categorias.forEach((item) => {
    //   console.log(item)
    //   categoriasAgrupadas[tipoCategoria].push(item);
    // })


    categorias.forEach((item) => {
      const tipoCategoria = item;

     
     

      if (!categoriasAgrupadas[tipoCategoria]) {
        categoriasAgrupadas[tipoCategoria] = [];
      }
      const filterSubCat =  subcategorias.filter( subCat => subCat.categoria ==  tipoCategoria)
      
      categoriasAgrupadas[tipoCategoria].push(...filterSubCat);
    });



    const categoryOrder = ["Residenciais", "Comerciais", "Rurais", "Outros"];

    const sortedCategories = Object.keys(categoriasAgrupadas).sort((a, b) =>
    categoryOrder.indexOf(a) - categoryOrder.indexOf(b)
    );
      // Create a new object with sorted categories
      const sortedData = {};
      sortedCategories.forEach(category => {
          sortedData[category] = categoriasAgrupadas[category];
      });

     
      

     
 

    let htmlGrupo = "";
    for (const key in sortedData) {
      const item = categoriasAgrupadas[key];


      let specialCategories = [];

      if(key == 'Residenciais'){
        specialCategories = ["apartamento", "cobertura", "casa/sobrado", "terreno/lote", "vaga de garagem"]
      }else if(key == 'Comerciais'){
        specialCategories = ["hotéis", "salas/escritórios", "galpão", "terreno/lote comercial", "imóveis comerciais"]
      }else if(key == 'Rurais'){
        specialCategories = ["glebas", "fazenda", "chácara / sítio"]
      }
      else if(key == 'Outros'){
        specialCategories = ["veículos", "diversos"]
      }
      
     
      const htmlCategoria = item
        .sort((a, b) => {
          // Check if both categories are in the specialCategories array
          const aIndex = specialCategories.indexOf(a.subcategoria.toLowerCase());
          const bIndex = specialCategories.indexOf(b.subcategoria.toLowerCase());

          // If both categories are in the specialCategories array, sort based on their index
          if (aIndex !== -1 && bIndex !== -1) {
              return aIndex - bIndex;
          }
          
          // If only one of them is in the specialCategories array, prioritize it
          if (aIndex !== -1) {
              return -1;
          }
          if (bIndex !== -1) {
              return 1;
          }
        return false
          // If none of them are in the specialCategories array, sort alphabetically
          // return a.subcategoria.localeCompare(b.subcategoria);
      })
        .map((cat) => {
          const urlParams = selectCheckedLoad("categoria");
       
          return `
              
                <label class="checkbox-container">
                    <input ${
                      urlParams.includes(cat.id?.toString()) && "checked"
                    }  type="checkbox" name="categoria" value="${cat.id}">
                    ${cat.subcategoria.toLowerCase()}
                </label>
                
                `;
        })
        .join("");


    
      htmlGrupo += `
            <div class="col-1">
                <h3 class="title-dropdown">${key}</h3>
                ${htmlCategoria}
            </div>
            `;
    }

    if (wrapperContainer) {
      wrapperContainer.innerHTML = htmlGrupo;
    }
  }

  function renderizarEstado(estados) {
    
    const wrapperEstados = document.querySelector("#estado-dropdown .cols");
    const htlmEstados = estados
      .map((estado) => {
        const urlParams = selectCheckedLoad("estado");
        
        return `
            <label class="checkbox-container">
            <input ${
              urlParams.includes(estado.id?.toString()) && "checked"
            } type="checkbox" name="estado" value="${estado.id}">
            ${estado.nome.toLowerCase()}
            </label>
            `;
      })
      .join("");

    if (wrapperEstados) {
      wrapperEstados.innerHTML = htlmEstados;
    }
  }

  function renderizarCidades(cidades) {
    const wrapperContainer = document.querySelector("#cidade-dropdown .cols");


    const orderCidades = cidades?.sort((a, b) => {
      const nomeA = a["cidade__nome"].toLowerCase();
      const nomeB = b["cidade__nome"].toLowerCase();
  
      if (nomeA < nomeB) return -1;
      if (nomeA > nomeB) return 1;
      return 0;
  });
  
    
    const htmlCidades = orderCidades 
      .map((cidade) => {
        const urlParams = selectCheckedLoad("cidade");
        return `
            <label class="checkbox-container">
            <input ${
              urlParams.includes(cidade.cidade__id?.toString()) && "checked"
            } type="checkbox" name="cidade" value="${cidade.cidade__id}">
            ${cidade.cidade__nome.toLowerCase()}
            </label>
            `;
      })
      .join("");

    if (wrapperContainer) {
      wrapperContainer.innerHTML = htmlCidades;
    }
  }

  async function carregarCidadesDosEstados(selectedEstadoIds) {
  
   
    try {
      const estadosParametros = selectedEstadoIds
        .map((estadoId) => `estado=${estadoId}`)
        .join("&");
      const response = await axios.get(`/filters/?${estadosParametros}`);

      if (response.data && response.data.cidades) {
        renderizarCidades(response.data.cidades);

        const cidadeTrigger = document.querySelector('#cidade-button')
        if(cidadeTrigger){
         
          cidadeTrigger.click()
         cidadeTrigger.click()
        }

        // aqui
      } else {
        renderizarCidades([]);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const estadoDropdown = document.querySelector("#estado-dropdown");

  estadoDropdown?.addEventListener("change", function (event) {
    const selectedEstados = document.querySelectorAll(
      '#estado-dropdown input[type="checkbox"]:checked'
    );
    selectedEstadoIds = Array.from(selectedEstados, (estado) => estado.value);
   
    if (selectedEstadoIds.length > 0) {
      carregarCidadesDosEstados(selectedEstadoIds);
    } else {
      renderizarCidades([]);
    }
  });

  function renderizarBairros(bairros) {
    const wrapperContainer = document.querySelector("#bairro-dropdown .cols");

 
    const htmlBairros = bairros.sort((a, b) => {
      const nomeA = a.toLowerCase();
      const nomeB = b.toLowerCase();
  
      if (nomeA < nomeB) return -1;
      if (nomeA > nomeB) return 1;
      return 0;
      }).map((bairro) => {
        const urlParams = selectCheckedLoad("bairro");
        return `
            <label class="checkbox-container">
            <input ${
              urlParams.includes(bairro?.toString()) && "checked"
            } type="checkbox" name="bairro" value="${bairro}">
            ${bairro.toLowerCase()}
            </label>
            `;
      })
      .join("");

    if (wrapperContainer) {
      wrapperContainer.innerHTML = htmlBairros;
    }
  }

  async function carregarBairrosDaCidade(url) {
    console.log(url)
    try {
      const response = await axios.get(`/filters/${url}`);

      if (response.data && response.data.bairros) {
        renderizarBairros(response.data.bairros);

       const bairrosDropdown = document.querySelector('#bairro-button')
       if(bairrosDropdown){
        bairrosDropdown.click()
        bairrosDropdown.click()
       }

      } else {
        renderizarBairros([]);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const cidadeDropdown = document.querySelector("#cidade-dropdown");

  cidadeDropdown?.addEventListener("change", function (event) {
    const selectedCidades = document.querySelectorAll(
      '#cidade-dropdown input[type="checkbox"]:checked'
    );
    const selectedCidadeIds = Array.from(
      selectedCidades,
      (cidade) => cidade.value
    );

    function createQueryStringWithKey(key, values) {
      const queryStringValues = values.map(
        (value) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      );
      return `?${queryStringValues.join("&")}`;
    }

    const key = "cidade";
    const values = ["são paulo", "Pedra Azul"];

    const queryString = createQueryStringWithKey(key, selectedCidadeIds);

    if (selectedCidadeIds.length > 0) {

    
  
      carregarBairrosDaCidade(queryString);
    }
  });

  function renderizarFaixaPreco(faixasDePreco) {
    const wrapperContainer = document.querySelector("#preco-dropdown");

    const htmlFaixasDePreco = faixasDePreco
      .map((faixa) => {
        const urlParams = selectCheckedLoad("faixa_preco");
        return `
          <label class="checkbox-container">
            <input ${
              urlParams.includes(faixa?.toString()) && "checked"
            } type="checkbox" name="faixa_preco" value="${faixa}">
            ${faixa}
          </label>
        `;
      })
      .join("");

    if (wrapperContainer) {
      wrapperContainer.innerHTML = htmlFaixasDePreco;
    }
  }

  function getTotal() {
    const items = document.querySelectorAll(".list-items .item");

    items.forEach((item) => {
      const inputs = item.querySelectorAll("input");
      const totalEl = item.querySelector(".total-items");
      let totalChecked = 0;
      inputs.forEach((input) => {
        if (input.checked) {
          totalChecked++;
        }
      });

      if (totalChecked) {
        totalEl.innerText = totalChecked;
      } else if (totalEl) {
        totalEl.innerText = "";
      }
    });
  }

  axios
    .get("/filters/")
    .then((response) => {
      if (response.data && response.data.estados) {
        renderizarCategoria(response.data.categorias,response.data.subcategorias );
        renderizarEstado(response.data.estados);


       

        renderizarFaixaPreco(response.data.faixas_preco);


        const estado = selectCheckedLoad("estado");
        const cidades = selectCheckedLoad("cidade"); 
        console.log('estado ', estado)
        console.log(cidades , 'cidades')
        const dropIconTrigger = document.querySelector('#estado-button')
        const   categoriasnTrigger = document.querySelector('#categorias-button')
        const   precoTrigger = document.querySelector('#preco-button')
        if(precoTrigger){
          precoTrigger.click()
          precoTrigger.click()
        }
        if(categoriasnTrigger){
          categoriasnTrigger.click()
          categoriasnTrigger.click()
        }
        if(dropIconTrigger){
          dropIconTrigger.click()
          dropIconTrigger.click()
     
        }
        

        if(estado && estado.length){
          carregarCidadesDosEstados(estado)
        }
        if(cidades &&  cidades.length){

         

            const cidadeParametros = cidades
          .map((cidadeId) => `cidade=${cidadeId}`)
          .join("&");
          console.log('paramsss',cidadeParametros);
          carregarBairrosDaCidade(`?${cidadeParametros}`)
        }
        getTotal();
      }
    })
    .catch((error) => {
      console.error(error);
    });

  const items = document.querySelectorAll(".list-items .item");
  items?.forEach((item) => {
    item?.addEventListener("click", (e) => {
      const listaItems = e.target.closest(".list-items .item");
      const inputs = listaItems.querySelectorAll("input");
      const totalEl = item.querySelector(".total-items");
      let totalChecked = 0;

      inputs.forEach((input) => {
        if (input.checked) {
          totalChecked++;
        }
      });
      console.log("Total de itens checados:", totalChecked);
      if (!totalEl) return;
      if (totalChecked) {
        totalEl.innerText = totalChecked;
        totalEl.style.display = "inline-block";
      } else {
        totalEl.innerText = "";
        totalEl.style.display = "none";
      }
    });
  });

  const formFilter = document.querySelector('#filter form'); 
  
  formFilter.addEventListener('submit', (e) => {
    e.preventDefault()

    let inputSearch = formFilter.querySelector('.busca')
    let userSearch = inputSearch.value
    let clearSpace = userSearch.trim()
    
    if (clearSpace) {
      const radioTodosLeiloes = document.querySelector('.home-list-filter-bottom [data-filter="all"]')
			const checkboxes = formFilter.querySelectorAll('[type="checkbox"]')
			
			checkboxes.forEach(cb => cb.checked = false)
      radioTodosLeiloes.click()
    }
    
    e.target.submit()
    inputSearch.value = clearSpace
  })

  function filtrosTipoLeilao() {
    const btnsDataFilter = document.querySelectorAll('[data-filter]')
    const params = new URLSearchParams(window.location.search)
    const selectedTyes = params.getAll('tipo_leilao')

    const createInputs = (types) => types.forEach(type => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'tipo_leilao'
      input.value = type
      formFilter.appendChild(input)
    })
    
    if (selectedTyes.length) createInputs(selectedTyes)
      
    // Adicionando classe inicial
    if (selectedTyes.length === 1)
      btnsDataFilter[2].querySelector('.pin').classList.add('active')
    else if (selectedTyes.length > 1)
      btnsDataFilter[1].querySelector('.pin').classList.add('active')
    else
      btnsDataFilter[0].querySelector('.pin').classList.add('active')
    
    btnsDataFilter.forEach(btn => btn.addEventListener('click', () => {
      [...formFilter.querySelectorAll('input[name="tipo_leilao"]')].forEach(el => el?.remove())
      btnsDataFilter.forEach(btn => btn?.querySelector('.pin.active')?.classList.remove('active'))
      btn.querySelector('.pin').classList.add('active')

      const types = {
        all: [],
        trt: ["TRT"],
        not_trt: [
          "JUDICIAL",
          "EXTRAJUDICIAL",
          "ALIENAÇÃO PARTICULAR",
          "BENEFICENTE"
        ]
      }
      
      const btnType = btn.dataset.filter
      createInputs(types[btnType])
      // formFilter.submit()
    }))
  }

	function fillSearch() {
		const params = new URLSearchParams(window.location.search)
		const search = params.get('search')

		if (search) {
			document.querySelector('form [name="search"]').value = search
		}
	}

  filtrosTipoLeilao()
	fillSearch()
}
